module.exports = __webpack_public_path__ + "img/case12.ebc754c8.png";